import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddFoodCardFailureReasonRequest } from '@libs/shared/api';
import { AddFoodCardFailureReasonDialogComponent } from '@libs/shared/ui/dialogs/add-food-card-failure-reason-dialog/add-food-card-failure-reason-dialog.component';

@Injectable()
export class AddFoodCardFailureReasonDialogService {
  readonly matDialog = inject(MatDialog);

  // prettier-ignore
  open(isAdmin: boolean): MatDialogRef<AddFoodCardFailureReasonDialogComponent, AddFoodCardFailureReasonRequest> {
    return this.matDialog.open(AddFoodCardFailureReasonDialogComponent, {
      autoFocus: true,
      disableClose: false,
      data: { isAdmin },
    });
  }
}
